<div id="calendar-view">
    <div class="top-details">
        <h3>Días festivos</h3>
        <button class="right-icon add" mat-icon-button (click)="addvacation(null)"><mat-icon class="mat-icon">add</mat-icon></button>
        <div class="year-holiday-select">
            <!-- <mat-label>Select an option</mat-label> -->
            
            <mat-form-field appearance="fill">
              <mat-select (valueChange)="dateChange($event)" [(value)]="selectedYear">
                <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option> 
              </mat-select>
            </mat-form-field>
        </div>
        
    </div>
    <div class="list-holidyas">
        <div class="list-holidyas-table">
            <table aria-describedby="" mat-table [dataSource]="leavesDataSource">
          
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th  mat-header-cell *matHeaderCellDef> Días festivos </th>
                <td mat-cell *matCellDef="let element"> {{element.fecha | date: 'dd/MM/yyyy'}} </td>
              </ng-container>

              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let element"> <button (click)="deleteFecha(element)" class="right-icon del" mat-icon-button><mat-icon class="mat-icon">delete_forever</mat-icon></button> </td>
              </ng-container>
          
              <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr> -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
    </div>
</div>